export default "__VITE_ASSET__Ovn6IeX3__"